import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Segment, Accordion, Icon, Table } from 'semantic-ui-react';
import _ from 'underscore';
import { getAllJob } from "../../../actions";
import { JOB_TYPE } from "../../../constants";
import UploadUserResult from "../../../component/sysadmin/user/upload_user_results";

class JobListPage extends React.Component {

    state = {
        jobArray: [],
        loadingJob: true,
    }

    componentWillMount() {
        if (this.props.user.accessToken) {
            this.props.getAllJob(this.props.user.accessToken, {type:JOB_TYPE.UPLOAD_USER_RESULT}, (result) => {
                this.setState({
                    loadingJob: false,
                    jobArray: result.data.allJob
                })
            })
        }
    }

    render() {

        if (this.state.loadingJob) return "Loading";

        return (
            <>
                {this.state.jobArray.map(job => (
                    <UploadUserResult job={job} key={job._id} />

                ))}
            </>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
    };
}

export default connect(mapStateToProps, {
    getAllJob
})(withRouter(JobListPage))